import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-image-slider-dialog',
    styleUrls: ['./modal-image-slider-dialog.component.scss'],
    templateUrl: './modal-image-slider-dialog.component.html',
})
export class ModalImageSliderDialogComponent {
    public title: string;
    public firstMessage: string;
    public images: any;

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cerrar';

    constructor(public dialogRef: MatDialogRef<ModalImageSliderDialogComponent>) {
        this.images = [];
    }

    public set okButtonText(value: string) {
        this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
        this.cancelButtonTextLabel = value;
    }

    async download() {

        var index = 0;
        for (let image of this.images.value) {
            await this.delay(1000);
            const link = document.createElement('a');
            link.href = await this.toDataURL(image);
            link.download = "imagen_" + index + ".jpg";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            index++;
        }
    }
    toDataURL(url) {
        return fetch(url).then((response) => {
            return response.blob();
        }).then(blob => {
            return URL.createObjectURL(blob);
        });
    }
    delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-image-slider-dialog.component.ts